import React, { Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage, faCheck, faTimes, faTrashAlt, faDownload } from '@fortawesome/free-solid-svg-icons';
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class ClientTraining extends React.Component {

    constructor(props) {
        super(props);

        this.blankTraining = {
            file: null,
            shortDescription: '',
            longDescription: '',
            relatedServiceID: 0,
            uuid: '',
            clientId: 0,
            fileId: 0
        }

        this.state = {
            newClientTraining: JSON.parse(JSON.stringify(this.blankTraining)),
            editClientTraining: JSON.parse(JSON.stringify(this.blankTraining)),
            editClientTrainingId: 0,
            randomKey: new Date().getTime(),
            uploading: false,
            files: []
        };

    }

    componentDidMount = () => {
        this.getFiles();
    }

    humanFileSize = (bytes, dp = 1) => {
        const thresh = 1000;

        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }

        const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let u = -1;
        const r = 10 ** dp;

        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

        return bytes.toFixed(dp) + ' ' + units[u];
    }

    onDownload = (href, filename, e) => {
        this.props.log('ClientTraining.js/onDownload (href,filename,e)', href, filename, e);
        e.stopPropagation();
        fetch(href + filename + "?" + new Date().getTime(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', decodeURIComponent(filename));
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }


    formatDate = (d) => {
        this.props.info('ClientTraining.js/formatDate (d)', d);
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    getFiles = () => {
        this.props.log('ClientTraining.js/getFiles');
        // return;
        fetch('/api/files/' + this.props.clientId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        files: results.data.filter(file => file.type === 'training')
                    });
                } else {
                    this.props.addToast('Unable to load files.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleUpload = (e, edit) => {
        this.props.log('ClientTraining.js/handleUpload (e,edit)', e, edit);
        let f = e.target.files[0];
        let reader = new FileReader();
        if (typeof (f) !== 'object') return;
        try {
            reader.readAsDataURL(f);
            reader.onload = () => {
                let file = {
                    name: f.name,
                    type: f.type,
                    size: f.size,
                    base64: reader.result,
                };
                const stateVar = (edit) ? 'editClientTraining' : 'newClientTraining';
                this.setState((prevState) => {
                    const sel = { ...prevState };
                    sel[stateVar].file = file;
                    return sel;
                })
            }
        } catch (e) {
            this.props.addToast('An error has occurred.', 5, 'danger');
        }
    }

    onChange = (e, edit) => {
        this.props.log('ClientTraining.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        const stateVar = (edit) ? 'editClientTraining' : 'newClientTraining';
        this.setState(prevState => {
            const sel = { ...prevState };
            switch (e.target.name) {
                default:
                    sel[stateVar][e.target.name] = e.target.value;
            }
            return sel
        });
    }

    handleAdd = () => {
        this.props.log('ClientTraining.js/uploadFiles ()');
        this.setState({
            uploading: true
        }, () => {
            const json_request = JSON.stringify({
                clientId: this.props.clientId,
                reportId: null,
                auth0: this.props.user,
                type: 'training',
                filename: this.state.newClientTraining.file.name,
                filesize: this.state.newClientTraining.file.size,
                filetype: this.state.newClientTraining.file.type,
                data: this.state.newClientTraining.file.base64,
                meta: JSON.stringify({
                    shortDescription: this.state.newClientTraining.shortDescription,
                    longDescription: this.state.newClientTraining.longDescription,
                    relatedServiceID: this.state.newClientTraining.relatedServiceID
                })
            });
            fetch('/api/files/', {
                method: 'POST',
                body: json_request,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            }).then(results => results.json())
                .then(results => {
                    results.success ?
                        this.setState({
                            uploading: false,
                        }, () => {
                            this.getFiles();
                            this.props.addToast('File uploaded successfully.', 5, 'success')
                        })
                        :
                        this.setState({
                            uploading: false,
                        }, () => this.props.addToast('Unable to upload file.', 5, 'danger'))
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        })
    };

    onEdit = (id) => {
        this.props.log('ClientTraining.js/onEdit (id)', id);
        const training = [...this.state.files].filter(item => item.fileId === id)[0];
        const trainingMeta = training.meta != null && training.meta !== '' ? JSON.parse(training.meta) : { shortDescription: '', longDescription: '', relatedServiceID: 0 }
        this.setState({
            editClientTraining: {
                fileId: id,
                uuid: training.uuid,
                clientId: this.props.clientId,
                file: {
                    name: training.filename
                },
                shortDescription: trainingMeta.shortDescription,
                longDescription: trainingMeta.longDescription,
                relatedServiceID: trainingMeta.relatedServiceID,
            },
            editClientTrainingId: id,
            randomKey: new Date().getTime()
        })
    }

    onDelete = (id) => {
        this.props.log('ClientTrainings.js/onDelete (id)', id);
        fetch('/api/files/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getFiles();
                    this.props.addToast('Training deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete training.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEdit = () => {
        this.props.log('ClientTrainings.js/handleEdit');
        if (this.state.editClientTraining.file.base64 != null) {
            // delete old
            fetch('/api/files/' + this.state.editClientTraining.uuid, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        // add new
                        const json_request = JSON.stringify({
                            clientId: this.props.clientId,
                            reportId: null,
                            auth0: this.props.user,
                            type: 'training',
                            filename: this.state.editClientTraining.file.name,
                            filesize: this.state.editClientTraining.file.size,
                            filetype: this.state.editClientTraining.file.type,
                            data: this.state.editClientTraining.file.base64,
                            meta: JSON.stringify({
                                shortDescription: this.state.editClientTraining.shortDescription,
                                longDescription: this.state.editClientTraining.longDescription,
                                relatedServiceID: this.state.editClientTraining.relatedServiceID
                            })
                        });
                        fetch('/api/files/', {
                            method: 'POST',
                            body: json_request,
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.props.clientToken
                            }
                        }).then(results => results.json())
                            .then(results => {
                                results.success ?
                                    this.setState({
                                        uploading: false,
                                    }, () => {
                                        this.getFiles();
                                        this.props.addToast('File replaced successfully.', 5, 'success')
                                    })
                                    :
                                    this.setState({
                                        uploading: false,
                                    }, () => this.props.addToast('Unable to replace file.', 5, 'danger'))
                            })
                            .catch(() => {
                                this.props.addToast('An error has occurred.', 5, 'danger');
                            })
                    } else {
                        this.props.addToast('Unable to replace file.', 5, 'danger')
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        } else {
            // edit current
            const json_request = JSON.stringify({
                meta: JSON.stringify({
                    shortDescription: this.state.editClientTraining.shortDescription,
                    longDescription: this.state.editClientTraining.longDescription,
                    relatedServiceID: this.state.editClientTraining.relatedServiceID
                })
            });
            fetch('/api/files/' + this.state.editClientTraining.uuid, {
                method: 'PUT',
                body: json_request,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            }).then(results => results.json())
                .then(results => {
                    results.success ?
                        this.setState({
                            editClientTraining: JSON.parse(JSON.stringify(this.blankTraining)),
                            editClientTrainingId: 0
                        }, () => {
                            this.getFiles();
                            this.props.addToast('Training updated successfully.', 5, 'success')
                        })
                        :
                        this.props.addToast('Unable to update training.', 5, 'danger');
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        }


    }

    handleReset = () => {
        this.props.log('ClientTraining.js/handleReset');
        this.setState({
            newClientTraining: JSON.parse(JSON.stringify(this.blankTraining)),
            randomKey: new Date().getTime()
        })
    }

    handleCancel = () => {
        this.props.log('ClientTraining.js/handleCancel');
        this.setState({
            editClientTraining: JSON.parse(JSON.stringify(this.blankTraining)),
            editClientTrainingId: 0,
            randomKey: new Date().getTime()
        })
    }

    standardRow = (file) => {
        this.props.info('ClientTraining.js/standardRow (file)', file);
        let meta = (file.meta != null) ? JSON.parse(file.meta) : null;
        return (
            <Row className="adminRow pointer workflowRow" onClick={() => this.onEdit(file.fileId)}>
                <Col md={3} className="text-left">
                    <Button className='p-0 m-0 mb-1' color="link" onClick={(e) => this.onDownload("/uploads/" + file.uuid + '/', file.filename, e)}><FontAwesomeIcon icon={faDownload} /> {decodeURIComponent(file.filename)}</Button>
                    <span className='ml-2'>({this.humanFileSize(file.filesize)})</span>
                </Col>
                <Col md={3}>
                    {meta != null && meta.shortDescription != null ? meta.shortDescription : ''}
                </Col>
                <Col md={2}>
                    {meta != null && meta.shortDescription != null && this.props.clientData.services != null && this.props.clientData.services.findIndex(service => service.serviceId === parseInt(meta.relatedServiceID)) > -1
                        ? this.props.clientData.services.filter(service => service.serviceId === parseInt(meta.relatedServiceID))[0].name : ''}
                </Col>
                <Col md={2} className="text-left">
                    {this.formatDate(file.timestamp)}
                </Col>
                <Col md={2} className="text-left">
                    {file.firstName} {file.lastName}
                </Col>
            </Row>
        )
    }

    editRow = (training) => {
        this.props.log('ClientTraining.js/editRow (training)', training);
        return (<>
            <Row key={"edit" + training.fileId} className="adminRow activeTab align-items-bottom py-4 text-left">
                <Col md={8}>
                    <Row>
                        <Col>
                            <Label className="btn btn-secondary">
                                <FontAwesomeIcon icon={faImage} className="mr-1" />
                                Replace File
                                <Input
                                    className="fileButton"
                                    type="file"
                                    key={this.state.randomKey}
                                    name={"file_"}
                                    id="file"
                                    accept='.jpg,.png,.gif'
                                    onChange={e => this.handleUpload(e, true)}
                                />
                            </Label>
                            {this.state.editClientTraining.file != null && this.state.editClientTraining.file.name !== '' && <span className='ml-2 font-weight-bold'>{this.state.editClientTraining.file.name}</span>}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input
                                type="textarea"
                                rows={3}
                                name="shortDescription"
                                placeholder='Short Description'
                                value={this.props.isFieldNull(this.state.editClientTraining.shortDescription)}
                                onChange={e => this.onChange(e, true)} >
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input
                                type="textarea"
                                rows={4}
                                name="longDescription"
                                placeholder='Long Description'
                                value={this.props.isFieldNull(this.state.editClientTraining.longDescription)}
                                onChange={e => this.onChange(e, true)} >
                            </Input>
                        </Col>
                    </Row>
                    {this.props.clientData.services != null && this.props.clientData.services.length > 0 && <Row>
                        <Col>
                            <Input
                                type="select"
                                name="relatedServiceID"
                                value={this.props.isFieldNull(this.state.editClientTraining.relatedServiceID)}
                                onChange={e => this.onChange(e, true)} >
                                <option value={0}>SELECT SERVICE</option>
                                {this.props.clientData.services.map(service => (
                                    <option key={service.serviceId} value={service.serviceId}>{service.name}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>}
                </Col>
                <Col md={4} className="text-right">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Client Trainings">
                        <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit Training">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Client Trainings">
                        <ConfirmButton className="mx-1" color="danger" onClick={() => this.onDelete(this.state.editClientTraining.uuid)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        </>
        )
    }

    addRow = () => {
        this.props.info('ClientTraining.js/addRow');
        return (
            <>
                <Row className="py-4 text-left align-items-bottom ">
                    <Col md={8}>
                        <Row>
                            <Col>
                                <Label className="btn btn-secondary">
                                    <FontAwesomeIcon icon={faImage} className="mr-1" />
                                    Upload File
                                    <Input
                                        className="fileButton"
                                        type="file"
                                        key={this.state.randomKey}
                                        name={"file_"}
                                        id="file"
                                        accept='.jpg,.png,.gif'
                                        onChange={e => this.handleUpload(e)}
                                    />
                                </Label>
                                {this.state.newClientTraining.file != null && this.state.newClientTraining.file.name !== '' && <span className='ml-2 font-weight-bold'>{this.state.newClientTraining.file.name}</span>}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    type="textarea"
                                    rows={3}
                                    name="shortDescription"
                                    placeholder='Short Description'
                                    value={this.props.isFieldNull(this.state.newClientTraining.shortDescription)}
                                    onChange={e => this.onChange(e)} >
                                </Input>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    type="textarea"
                                    rows={4}
                                    name="longDescription"
                                    placeholder='Long Description'
                                    value={this.props.isFieldNull(this.state.newClientTraining.longDescription)}
                                    onChange={e => this.onChange(e)} >
                                </Input>
                            </Col>
                        </Row>
                        {this.props.clientData.services != null && this.props.clientData.services.length > 0 && <Row>
                            <Col>
                                <Input
                                    type="select"
                                    name="relatedServiceID"
                                    value={this.props.isFieldNull(this.state.newClientTraining.relatedServiceID)}
                                    onChange={e => this.onChange(e)} >
                                    <option value={0}>SELECT SERVICE</option>
                                    {this.props.clientData.services.map(service => (
                                        <option key={service.serviceId} value={service.serviceId}>{service.name}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>}
                    </Col>
                    <Col md={4} className="text-right">
                        {this.state.newClientTraining.file != null && <Button
                            className='mr-2'
                            color="secondary"
                            onClick={this.handleReset}
                        >Reset</Button>}
                        <Button
                            disabled={this.state.newClientTraining.file == null}
                            color="primary"
                            onClick={this.handleAdd}
                        >Add File</Button>
                    </Col>

                </Row>
            </>
        )
    }

    render() {
        this.props.info('ClientTraining.js/render');
        return (
            <Container className="text-left" fluid>
                {this.state.files.length > 0 ? <Row className="adminRow pointer workflowRow font-weight-bold">
                    <Col md={3} className="text-left">
                        File
                    </Col>
                    <Col md={3}>
                        Short Description
                    </Col>
                    <Col md={2}>
                        Service
                    </Col>
                    <Col md={2} className="text-left">
                        Uploaded
                    </Col>
                    <Col md={2} className="text-left">
                        Author
                    </Col>
                </Row> : <Row><Col className="font-weight-bold">No files available</Col></Row>}
                {this.state.files.map(file => (
                    <Fragment key={file.fileId}>{this.state.editClientTrainingId === file.fileId ? this.editRow(file) : this.standardRow(file)}</Fragment>
                ))}
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Client Trainings">
                    <Row>
                        <Col>
                            {this.addRow()}
                        </Col>
                    </Row>
                </PermissionWrapper>
            </Container>
        );
    }
}

export default ClientTraining;